module.exports = __webpack_public_path__ + "img/retail.0fd753a8.png";